<app-logo-area
  [breadcrumbs]="[{'display': 'Content Platform', commands: null}]"></app-logo-area>
<main>

  <app-headline-section [title]="'Signiant Connectors'">
  </app-headline-section>

  <section class="cl-section cl-section-regular">
    <div class="container">
      <div class="row">
        <div class="col-12 col-lg-8">
          <p class="cl-p-large">
            Every Media Shuttle portal we move content through — inbound from a
            supplier's portal into the repository, outbound from a finished order to a
            customer's. Open one to see its session, browse its files and follow its
            transfers.
          </p>
        </div>
      </div>
    </div>
  </section>

  @if (error()) {
    <section class="cl-section cl-section-regular">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <p class="cl-p-regular cl-color-brick">Could not load portals: {{ error() }}</p>
          </div>
        </div>
      </div>
    </section>
  }

  <section class="cl-section cl-section-regular">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <table style="table-layout: fixed;" class="cl-table-data">
            <colgroup>
              <col style="width: 100%">
              <col style="width: 110px">
              <col style="width: 140px">
              <col style="width: 396px">
              <col style="width: 160px">
            </colgroup>
            <thead>
              <tr>
                <th class="cl-table-head cl-p-tiny">Portal</th>
                <th class="cl-table-head cl-p-tiny">What we do</th>
                <th class="cl-table-head cl-p-tiny">Session</th>
                <th class="cl-table-head cl-p-tiny">Account</th>
                <th class="cl-table-head cl-p-tiny">Last swept</th>
              </tr>
            </thead>
            <tbody>
              @if (loading()) {
                <tr class="cl-tr-no-data">
                  <td colspan="100" style="text-align: center">
                    Loading ...<i class="fas fa-spinner fa-spin"></i></td>
                </tr>
              }
              @for (portal of portals(); track portal.id) {
                <tr>
                  <td>
                    <a [routerLink]="['/o', organization()?.id, 'signiant-portals', portal.id]">
                      {{ portal.name }}
                    </a>
                    <p class="cl-p-tiny">{{ portal.portalUrl }}</p>
                  </td>
                  <td>
                    <span class="cl-badge cl-badge-sm cl-color-steel"
                          [title]="portal.kindHint">{{ portal.kind }}</span>
                  </td>
                  <td>
                    @if (portal.status?.loggedIn) {
                      <span class="cl-color-sea">Logged in</span>
                    } @else if (portal.status?.needsMfa) {
                      <span class="cl-color-sun">MFA required</span>
                    } @else {
                      <span class="cl-color-brick">Signed out</span>
                    }
                  </td>
                  <td>{{ portal.status?.username || '—' }}</td>
                  <td class="cl-td-date">{{ portal.lastSweepAt ? (portal.lastSweepAt | cldate) : '—' }}</td>
                </tr>
              }
              @if (!loading() && portals().length === 0 && !error()) {
                <tr class="cl-tr-no-data">
                  <td colspan="100" style="text-align: center">
                    No portals are configured for this organization.</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </section>
</main>
